export const CREATE_SUBSCRIPTION = 'createSubscription';
export const FETCH_SUBSCRIPTION_BY_WORKSPACE_ID = 'fetchSubscriptionByWorkspaceId';
export const FETCH_SUBSCRIPTION_BY_ID = 'fetchSubscriptionById';
export const UPDATE_SUBSCRIPTION_BY_ID = 'updateSubscriptionById';
